import { render, staticRenderFns } from "./EEscolhaDisciplinaMesPDF.vue?vue&type=template&id=0b5ccc23"
import script from "./EEscolhaDisciplinaMesPDF.vue?vue&type=script&lang=js"
export * from "./EEscolhaDisciplinaMesPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports